<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/iam/types';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from '@/iam/account/account-repository';

interface Data {
  task: Promise<Account[]>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  props: {
    accountType: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    accountType: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load(): void {
      this.task = repository.findAll({ type: this.accountType });
      this.task.then((accounts: Account[]) => {
        this.$emit('loaded', accounts);
      });
    },
  },
});
</script>
